
export const MODAL_SHARE_CALCULATION = 'MODAL_SHARE_CALCULATION';
export const MODAL_NEWS_LETTER = 'MODAL_NEWS_LETTER';
export const MODAL_QUESTION_INFO = 'MODAL_QUESTION_INFO';

export const LOCAL_STORAGE_NEWSLETTER_SIGNED_UP = 'LOCAL_STORAGE_NEWSLETTER_SIGNED_UP';
export const LOCAL_STORAGE_NEWSLETTER_LAST_ASKED = 'LOCAL_STORAGE_NEWSLETTER_LAST_ASKED';


// WEBPACK FOOTER //
// ./src/store/const.js